/**
 * i18n configuration for Kenbright : Terra17 Engine (terra17engine.com).
 *
 * Language setting is controlled by the Country Admin via the admin panel.
 * Only Company User dashboards are translated — all other role dashboards
 * remain in English regardless of the language setting.
 *
 * Supported languages: English (en), Kiswahili (sw), Français (fr),
 * Português (pt), العربية (ar).
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import sw from './locales/sw.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';
import ar from './locales/ar.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    sw: { translation: sw },
    fr: { translation: fr },
    pt: { translation: pt },
    ar: { translation: ar },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes output
  },
});

export default i18n;
